/* yourtheone — variant picker のネイティブ<select>をブランド統一のカスタムドロップダウンに置換
   ネイティブselectは裏で機能維持（Dawnのvariant-selectsが値を読む）。見た目だけ独自UI。
   dearcouple品質：閉じても開いてもブランドデザイン。 */
(function () {
  function build(select) {
    if (select.__cs) return;
    select.__cs = true;
    var wrap = select.closest('.select') || select.parentElement;
    if (!wrap) return;
    wrap.classList.add('cs-enhanced');
    select.classList.add('cs-native');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cs-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    var label = document.createElement('span');
    label.className = 'cs-trigger-label';
    var caret = document.createElement('span');
    caret.className = 'cs-caret';
    trigger.appendChild(label);
    trigger.appendChild(caret);

    var list = document.createElement('ul');
    list.className = 'cs-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    function syncLabel() {
      var o = select.options[select.selectedIndex];
      label.textContent = o ? o.textContent.trim() : '';
    }
    function rebuildOptions() {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt, i) {
        var li = document.createElement('li');
        li.className = 'cs-option';
        li.setAttribute('role', 'option');
        li.textContent = opt.textContent.trim();
        if (opt.disabled) li.classList.add('cs-disabled');
        if (i === select.selectedIndex) li.classList.add('cs-selected');
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          if (opt.disabled) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncLabel();
          list.querySelectorAll('.cs-option').forEach(function (x) { x.classList.remove('cs-selected'); });
          li.classList.add('cs-selected');
          close();
        });
        list.appendChild(li);
      });
    }
    function open() {
      // 他の開いてるドロップダウンを閉じる
      document.querySelectorAll('.select.cs-open').forEach(function (w) { if (w !== wrap) { w.classList.remove('cs-open'); var l = w.querySelector('.cs-list'); if (l) l.hidden = true; var t = w.querySelector('.cs-trigger'); if (t) t.setAttribute('aria-expanded', 'false'); } });
      rebuildOptions();
      list.hidden = false; wrap.classList.add('cs-open'); trigger.setAttribute('aria-expanded', 'true');
    }
    function close() { list.hidden = true; wrap.classList.remove('cs-open'); trigger.setAttribute('aria-expanded', 'false'); }

    trigger.addEventListener('click', function (e) { e.stopPropagation(); list.hidden ? open() : close(); });
    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // ネイティブselectが外部(variantロジック)で変わったらラベル同期
    select.addEventListener('change', syncLabel);

    syncLabel();
    rebuildOptions();
    wrap.appendChild(trigger);
    wrap.appendChild(list);
  }

  function enhanceAll() {
    document.querySelectorAll('.product__info-wrapper .select .select__select, .product-form__input--dropdown .select__select').forEach(build);
  }

  function boot() {
    enhanceAll();
    var root = document.querySelector('.product__info-wrapper') || document.querySelector('.product');
    if (root && window.MutationObserver) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; enhanceAll(); });
      });
      mo.observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
